import { gql } from "lib/apolloClient";
import {
  academicYearFragment,
  academicTermFragment,
} from "./AcademicYearTermsFragments";

export const getOrganizationAcademicYearsQuery = gql`
  query getOrganizationAcademicYears($id: ID!, $termsFilters: TermFilters) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        academicYears {
          ...academicYearBasicDetailsItem
        }
      }
    }
  }
  ${academicYearFragment.academicYearBasicDetailsWithFilters}
`;

export const getOrganizationAcademicYearsWithTermsQuery = gql`
  query getOrganizationAcademicYearsWithTerms($id: ID!) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        academicYears {
          id
          startDate
          endDate
          isCurrentAcademicYear
          terms {
            id
            label
            type
            startDate
            endDate
          }
        }
      }
    }
  }
`;

export const getAcademicYearDetailsQuery = gql`
  query getAcademicYearDetails($id: ID!, $curriculumProgramIds: [ID!]) {
    node(id: $id, type: ACADEMIC_YEAR) {
      id
      ... on AcademicYear {
        id
        startDate
        endDate
        dependentEntities {
          id
        }
        terms(filters: { curriculumProgramIds: $curriculumProgramIds }) {
          ...termBasicDetailsItem
        }
      }
    }
  }
  ${academicTermFragment.termBasicDetails}
`;

// Get dependent entities of cumulative terms (Only PROGRESS_REPORT_TASK_GROUP,TRANSCRIPT_YEAR_GROUP)
export const getCumulativeTermDependentEntitiesQuery = gql`
  query getCumulativeTermDependentEntities(
    $id: ID!
    $termFilters: TermFilters
    $academicTermDependentEntitiesFilter: AcademicTermDependentEntitiesFilter
  ) {
    node(id: $id, type: ACADEMIC_YEAR) {
      id
      ... on AcademicYear {
        id
        terms(filters: $termFilters) {
          id
          dependentEntitiesV2(filters: $academicTermDependentEntitiesFilter) {
            totalCount
          }
        }
      }
    }
  }
`;
